/*
 * Copyright (c) 2020 by Felix Heim, felix-heim@web.de
 *
 * This product includes software developed at
 * The Apache Software Foundation (http://www.apache.org/).
 */

(function() {
    'use strict';

    angular
        .module('askApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('board.dinghy.event.detail.booking', {
            parent: 'board.dinghy.event.detail',
            url: '/booking?page&sort&search',
            data: {
                authorities: ['ROLE_BOARD','ROLE_DINGHY'],
                pageTitle: 'askApp.booking.home.title3'
            },
            views: {
                'dinghyDetail@board.dinghy.event.detail': {
                    templateUrl: 'app/board/dinghy/event/detail/bookings/dinghy-bookings.html',
                    controller: 'DinghyEventDetailBookingController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'validationDate,desc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('dept');
                    $translatePartialLoader.addPart('booking');
                    $translatePartialLoader.addPart('dinghy');
                    $translatePartialLoader.addPart('dinghyBooking');
                    $translatePartialLoader.addPart('enumDeptStatus');
                    $translatePartialLoader.addPart('enumBookingStatusType');
                    return $translate.refresh();
                }]
            }
        })
        .state('board.dinghy.event.detail.booking.edit', {
            parent: 'board.dinghy.event.detail.booking',
            url: '/{idBooking}/edit',
            data: {
                authorities: ['ROLE_BOARD','ROLE_DINGHY']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', 'entity', function($stateParams, $state, $uibModal, entity) {
                $uibModal.open({
                    templateUrl: 'app/board/dinghy/event/detail/bookings/dinghy-booking-dialog.html',
                    controller: 'DinghyEventDetailBookingDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'md',
                    resolve: {
                        entityBooking: ['DinghyDetailBooking', function(DinghyDetailBooking) {
                            return DinghyDetailBooking.get({id : $stateParams.idBooking}).$promise;
                        }],
                        entity: entity,
                        translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                            $translatePartialLoader.addPart('settings');
                            return $translate.refresh();
                        }]
                    }
                }).result.then(function() {
                    $state.go('board.dinghy.event.detail.booking', null, { reload: 'board.dinghy.event.detail' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('board.dinghy.event.detail.booking.new', {
            parent: 'board.dinghy.event.detail.booking',
            url: '/new',
            data: {
                authorities: ['ROLE_BOARD','ROLE_DINGHY']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', 'entity', function($stateParams, $state, $uibModal, entity) {
                $uibModal.open({
                    templateUrl: 'app/board/dinghy/event/detail/bookings/dinghy-booking-dialog.html',
                    controller: 'DinghyEventDetailBookingDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'md',
                    resolve: {
                        entity: entity,
                        entityBooking: function () {
                            return {
                                id: entity.id,
                                bookingStatus: null,
                                comment: null,
                                individualQuestionAnswer: null,
                                dingy: null,
                                commentDinghy: null,
                                profile: {
                                    id: null,
                                    firstName: "",
                                    lastName: "",
                                    mail: "",
                                    phone: null
                                }
                            };
                        },
                        translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                            $translatePartialLoader.addPart('settings');
                            return $translate.refresh();
                        }]
                    }
                }).result.then(function() {
                    $state.go('board.dinghy.event.detail.booking', null, { reload: 'board.dinghy.event.detail' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('board.dinghy.event.detail.booking.delete', {
            parent: 'board.dinghy.event.detail.booking',
            url: '/{idBooking}/delete',
            data: {
                authorities: ['ROLE_BOARD','ROLE_DINGHY']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/board/dinghy/bookings/dinghy-booking-delete-dialog.html',
                    controller: 'BoardDinghyBookingDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['BoardDinghyBooking', function(BoardDinghyBooking) {
                            return BoardDinghyBooking.get({id : $stateParams.idBooking}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('board.dinghy.event.detail.booking', null, { reload: 'board.dinghy.event.detail' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('board.dinghy.event.detail.booking.edit-dept', {
            parent: 'board.dinghy.event.detail.booking',
            url: '/dept/{deptId}/edit',
            data: {
                authorities: ['ROLE_FINANCE']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/board/dept/dept-dialog.html',
                    controller: 'BoardDeptDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'md',
                    resolve: {
                        translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                            $translatePartialLoader.addPart('payment');
                            $translatePartialLoader.addPart('enumPaymentCategory');
                            return $translate.refresh();
                        }],
                        entity: ['Dept', function(Dept) {
                            return Dept.get({id : $stateParams.deptId}).$promise;
                        }],
                        entityProfile: null,
                        entityProject: null,
                        entityDinghyEvent: null
                    }
                }).result.then(function() {
                    $state.go('board.dinghy.event.detail.booking', null, { reload: 'board.dinghy.event.detail' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('board.dinghy.event.detail.booking.new-dept', {
            parent: 'board.dinghy.event.detail.booking',
            url: '/dept/new/{userId}',
            data: {
                authorities: ['ROLE_FINANCE']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', 'entity', function($stateParams, $state, $uibModal, entity) {
                $uibModal.open({
                    templateUrl: 'app/board/dept/dept-dialog.html',
                    controller: 'BoardDeptDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'md',
                    resolve: {
                        translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                            $translatePartialLoader.addPart('payment');
                            $translatePartialLoader.addPart('enumPaymentCategory');
                            return $translate.refresh();
                        }],
                        entity: function () {
                            return {
                                date: new Date(),
                                reference: null,
                                pointValue: 0,
                                amount: null,
                                comment: null,
                                category: "",
                                sepa: null,
                                paymentStatus: null,
                                id: null
                            };
                        },
                        entityProfile: ['MemberManagement', function(MemberManagement) {
                            return MemberManagement.get({id: $stateParams.userId}).$promise;
                        }],
                        entityProject: null,
                        entityDinghyEvent: entity
                    }
                }).result.then(function() {
                    $state.go('board.dinghy.event.detail.booking', null, { reload: 'board.dinghy.event.detail' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }
})();
